import { Controller } from "@hotwired/stimulus"
import { chordProMetadata } from "../lib/chordpro.js"

export default class extends Controller {
  static targets = ["title", "key", "tempo", "timeSignature", "body", "preview"]

  connect() {
    // Set initial preview with default values
    this.updatePreview()
  }

  updatePreview() {
    // Build ChordPro metadata preview
    const metadata = this.generateMetadata()
    // Update the preview element with formatted metadata
    this.previewTarget.textContent = metadata
  }

  generateMetadata() {
    return chordProMetadata({
      title: this.hasTitleTarget ? this.titleTarget.value : "",
      key: this.hasKeyTarget ? this.keyTarget.value : "",
      time: this.hasTimeSignatureTarget ? this.timeSignatureTarget.value : "",
      tempo: this.hasTempoTarget ? this.tempoTarget.value : "",
    })
  }
}
